/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Cancel = 'Website.Basket.MinimumSalesQuantity.Cancel';
export const AddBundleToBasket = 'Website.Basket.MinimumSalesQuantity.AddBundleToBasket';
